import { useRouter } from "next/router";
import React, { useMemo } from "react";
import { createContext, useContext, useEffect, useState } from "react";
import { getCategoryForPath } from "services/frontend/PageCategories";
import { baseUrl } from "services/shared/Environment";
const Url = require("url-parse");

export interface RoutingContextValue {
  referrer: string;
  referrer_type: string;
}

export const RoutingContextValue = createContext([]);

const defaultContextValues: RoutingContextValue = {
  referrer: "",
  referrer_type: "",
};

export const RoutingContext = createContext(defaultContextValues);

export const RoutingContextProvider: React.FC = ({ children }) => {

  const { asPath } = useRouter()
  const [history, setHistory] = useState([])

  useEffect(() => {
    setHistory(previous => [asPath, ...previous])
  }, [asPath])

  const referrer = useMemo(() => {
    let path = ''
    if(history.length > 0) {
      //for referrer, we want the first url which is not the current page path.
      path = history.filter((path) => path !== asPath)[0] ?? '';
      return `${baseUrl()}${path}`;
    } else {
      return global?.document?.referrer ?? ''
    }
  }, [global?.document?.referrer, history, asPath]);

  const referrer_type = useMemo(() => {
    let type = "";
    const referrerIsJgntPage = referrer.includes(baseUrl());
    const referrerUrl = new Url(referrer);
    if (referrerIsJgntPage) {
      const referrer_path = referrerUrl.pathname;
      type = getCategoryForPath(referrer_path);
    }
    return type;
  }, [referrer]);

  return (
    <RoutingContext.Provider
      value={{
        referrer,
        referrer_type,
      }}
    >
      {children}
    </RoutingContext.Provider>
  );
};

export function useRoutingContext() {
  const context = useContext(RoutingContext);
  return context;
}
